export const initialState = {
    loading: false,
    contactForm: null,
  };
  
  export type ContactState = Readonly<typeof initialState>;